"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var WebhookAuthenticationConfiguration_service_1 = __importDefault(require("./Service/WebhookAuthenticationConfiguration.service"));
var WebhookAuthenticationConfiguration = /** @class */ (function () {
    function WebhookAuthenticationConfiguration(session) {
        this.webhookAuthenticationConfigurationService = new WebhookAuthenticationConfiguration_service_1.default(session);
    }
    WebhookAuthenticationConfiguration.prototype.create = function (configuration) {
        return this.webhookAuthenticationConfigurationService.create(configuration);
    };
    WebhookAuthenticationConfiguration.prototype.list = function () {
        return this.webhookAuthenticationConfigurationService.list();
    };
    WebhookAuthenticationConfiguration.prototype.getById = function (id) {
        return this.webhookAuthenticationConfigurationService.getById(id);
    };
    WebhookAuthenticationConfiguration.prototype.update = function (id, configuration) {
        return this.webhookAuthenticationConfigurationService.update(id, configuration);
    };
    WebhookAuthenticationConfiguration.prototype.delete = function (id) {
        return this.webhookAuthenticationConfigurationService.delete(id);
    };
    return WebhookAuthenticationConfiguration;
}());
exports.default = WebhookAuthenticationConfiguration;
//# sourceMappingURL=WebhookAuthenticationConfiguration.js.map